import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { Button } from "@jti/ui/components/Button/Button";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import { X_SELLING_POPUP_GTM_CTA_LOCATION } from "../../../../features/XSellingDialog/const/tracking";
import styles from "./XSellingDialogProductCard.module.scss";
export const XSellingDialogProductCard = ({ name, description, productUrl, imgUrl, imgAlt, }) => {
    const { __ } = useTranslations();
    const ctaButtonLabel = __("x_selling_dialog.pdocut_card.cta_button_label");
    const handleCtaButtonClick = async () => {
        await dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
            cta_name: ctaButtonLabel,
            cta_location: X_SELLING_POPUP_GTM_CTA_LOCATION,
        });
        window.location.assign(productUrl);
    };
    return (_jsxs("div", { className: styles.product, children: [_jsx("img", { className: styles.miniature, src: imgUrl, alt: imgAlt }), _jsxs("div", { className: styles.productInfo, children: [_jsx("h3", { className: styles.productName, children: name }), _jsx("p", { className: styles.productDescription, children: description })] }), _jsx(Button, { color: "secondary", onClick: handleCtaButtonClick, size: "fullWidth", children: ctaButtonLabel })] }));
};
//# sourceMappingURL=XSellingDialogProductCard.js.map